import React, { useEffect, useState, useRef, useMemo } from "react";
import { useHistory } from "react-router-dom";

import SweetAlert from "sweetalert2";

import api from "../../../services/api";

import ContentHeader from "../../../components/ContentHeader";
import Content from "../../../components/Content";
import CardHeader from "../../../components/CardHeader";
import TableGrid from "../../../components/TableGrid";
import CardFooter from "../../../components/CardFooter";

import {
  ajustaActiveClassMenu,
  searchByAllKeys,
  decrypt,
} from "../../../util/rotinas";
import { toast } from "react-toastify";
import Button from "../../../components/Button";

export default function Instituiticao() {
  const [loading, setLoading] = useState(false);
  const [listInstituitions, setListInstituitions] = useState([]);
  const [listInstituiticaoFiltrado, setListInstituiticaoFiltrado] = useState([]);

  const [btnNovoInstituiticao, setBtnNovoInstituiticao] = useState(false);
  const [btnEditarInstituiticao, setBtnEditarInstituiticao] = useState(false);
  const [btnExcluirInstituiticao, setBtnExcluirInstituiticao] = useState(false);

  const history = useHistory();
  const searchRef = useRef(null);

  async function getInstituitions() {
    setLoading(true);
    await api
      .get(`instituition`)
      .then((res) => {
        const temp =  res.data.data.filter(instituiticao => !instituiticao.is_api)
        setListInstituitions(temp);
        setListInstituiticaoFiltrado(temp);
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setLoading(false);
      });
  }

  useEffect(() => {
    ajustaActiveClassMenu("conMenu", "instituitionMenu");

    const u = decrypt(localStorage.getItem("@ipm:user"), true);
    const acessos = u?.profile?.access;

    let aList;
    aList = acessos?.filter(
      (a) =>
        a.screen_name === "instituition" &&
        a.action === "new" &&
        a.has_access
    );
    if (aList.length !== 0) setBtnNovoInstituiticao(true);
    aList = acessos?.filter(
      (a) =>
        a.screen_name === "instituition" &&
        a.action === "edit" &&
        a.has_access
    );
    if (aList.length !== 0) setBtnEditarInstituiticao(true);
    aList = acessos?.filter(
      (a) =>
        a.screen_name === "instituition" &&
        a.action === "delete" &&
        a.has_access
    );
    if (aList.length !== 0) setBtnExcluirInstituiticao(true);

    getInstituitions();
  }, []);

  const deleteInstituiticao = function (obj) {

    SweetAlert.fire({
      title: "Confirma exclusão do(a) estabelecimento(a) ? ",
      text: `${obj?.name}`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Sim",
      cancelButtonText: "Não",
    }).then((result) => {
      if (result.isConfirmed) {
        api
          .delete(`/instituition/${obj.id}`)
          .then(() => {
            toast.success(`Estabelecimento excluído com sucesso.`, {
              position: "bottom-center",
              autoClose: true,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: false,
              draggable: true,
              progress: 0,
            });
            getInstituitions();
          })
          .catch((err) => {
            console.log(err);
          });
      }
    });

  };

  const columns = useMemo(() => [

    {
      name: "Id",
      selector: "id",
      sortable: true,
      width:"40px"
    },
    {
      name: "Name",
      selector: "name",
      sortable: true,
    },
    {
      cell: (row) => (
        <div className="btn-group btn-group-xs pull-right">
          {btnEditarInstituiticao ? (
            <>
              <button
                className="btn btn-default btn-xs"
                onClick={() => history.push("/instituition/instituition-edit/" + row.id)}
              >
                <i className="fa fa-fw fa-pencil"></i>
              </button>
            </>
          ) : null}
          {btnExcluirInstituiticao ? (
            <>
              <button
                onClick={() => deleteInstituiticao(row)}
                className="btn btn-danger btn-xs"
              >
                <i className="fa fa-fw fa-trash-o"></i>
              </button>
            </>
          ) : null}
        </div>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
    },
  ]);

  return (
    <>
      <ContentHeader
        urlPrevious="/"
        previousTitle=" Pagina Inicial"
        smallTitle="Instituições"
      />
      <Content>
        <CardHeader
          title={"Instituições"}
          icon={"fa-building"}
          searchVisible={true}
          searchRef={searchRef}
          onChange={() =>
            setListInstituiticaoFiltrado(searchByAllKeys(listInstituitions, searchRef))
          }
        />
        <TableGrid
          columns={columns}
          data={listInstituiticaoFiltrado}
          loading={loading}
        />
        {btnNovoInstituiticao ? (
          <CardFooter >
            <Button
              type="button"
              title="Novo"
              onClick={() => history.push("/instituition/instituition-new")}
            />
          </CardFooter>
        ) : null}
      </Content>
    </>
  );
}
